import { Nullable } from '@f-fertighaus/applications/Next/types/utility'

export function isNotEmptyArray<T>(
  variable?: Nullable<Array<T>>
): variable is [T, ...T[]] {
  return Boolean(variable && variable.length > 0)
}
